import { render, staticRenderFns } from "./RequisitionDetailActivityCard.vue?vue&type=template&id=22480a6a&"
import script from "./RequisitionDetailActivityCard.vue?vue&type=script&lang=ts&"
export * from "./RequisitionDetailActivityCard.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports